import { Box, lighten } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
 '& .ESPHeaderContainer':{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    gap: theme.spacing(6),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'start',
      gap: theme.spacing(4),
    },

 },
 '& .ESPSeeMoreBtn':{
    flexShrink: 0,
 },
 '& .ESPImgContainer':{
    width: '100%',
    height: theme.typography.pxToRem(150),
    overflow: 'hidden',
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(1.5),
  
 },
 '& .ESPGridCard':{
    [theme.breakpoints.down('xl')]: {
      '&:last-child ':{
          display: 'none',
        }
    },
    [theme.breakpoints.down('md')]: {
      '&:nth-last-child(-n+2)':{
          display: 'none',
        }
    },
 },
}));

export default StyledBox;
